import React from 'react';
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';

export function WorkspaceLoadingState({ label = 'Loading…', minHeight = 240 }) {
  return (
    <Box role="status" aria-live="polite" sx={{ minHeight, display: 'grid', placeItems: 'center', p: 3 }}>
      <Stack spacing={1.25} alignItems="center">
        <CircularProgress size={32} aria-hidden="true" />
        <Typography variant="body2" color="text.secondary">{label}</Typography>
      </Stack>
    </Box>
  );
}

export function WorkspaceEmptyState({ title, description, action, minHeight = 240 }) {
  return (
    <Box sx={{ minHeight, display: 'grid', placeItems: 'center', p: 3, textAlign: 'center' }}>
      <Box sx={{ maxWidth: 480 }}>
        <Typography component="h2" variant="subtitle1">{title}</Typography>
        {description ? <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{description}</Typography> : null}
        {action ? <Box sx={{ mt: 2 }}>{action}</Box> : null}
      </Box>
    </Box>
  );
}

export function WorkspaceErrorState({ message, onRetry, title = 'Something went wrong' }) {
  return (
    <Alert
      severity="error"
      role="alert"
      action={onRetry ? <Button color="inherit" size="small" startIcon={<RefreshIcon />} onClick={onRetry}>Try again</Button> : null}
    >
      <Typography component="h2" variant="subtitle2">{title}</Typography>
      <Typography variant="body2">{message}</Typography>
    </Alert>
  );
}
